export default __webpack_public_path__ + "static/media/brauneck.bd715db6.png";